import { render, staticRenderFns } from "./FooterArea.vue?vue&type=template&id=b86068a2&scoped=true"
import script from "./FooterArea.vue?vue&type=script&lang=js"
export * from "./FooterArea.vue?vue&type=script&lang=js"
import style0 from "./FooterArea.vue?vue&type=style&index=0&id=b86068a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86068a2",
  null
  
)

export default component.exports